import { useMutation } from '@tanstack/vue-query'
import { createBaseMutation } from './createBaseMutation'
import type {
    CreateMutationOptions,
    CreateMutationResult,
} from 'Common/types/utils/network/querykit/mutationTypes'

/* eslint-disable @typescript-eslint/no-explicit-any */
export function createMutation<
    TData = unknown,
    TVariables = void,
    TError = unknown,
    TContext = unknown
>(
    options: CreateMutationOptions<TData, TError, TVariables, TContext>,
): CreateMutationResult<TData, TError, TVariables> {

    return createBaseMutation(options, useMutation) as CreateMutationResult<TData, TError, TVariables>
}
/* eslint-enable @typescript-eslint/no-explicit-any */